// extracted by mini-css-extract-plugin
export var dot = "BigButton-module--dot--5GPc1";
export var home = "BigButton-module--home--E-IW4";
export var wrapper = "BigButton-module--wrapper--sCOaa";